import CONSTANTS from '~/global_helper/constants.js'

export default {
	middleware: 'guest',
	methods: {
		async loadRedirectUser(origin = null) {
			await this.$store.dispatch('Auth/fetchUser')
			const user = this.$store.getters['Auth/user']
			const accounts = this.$store.getters['Auth/accounts']
			const creatorsRealAccounts = Object.keys(accounts)
				.filter(key => !accounts[key]?.tmpLoginAsAdmin)
				.map(key => accounts[key])
			if (user) {
				this.$AdsTracking('track', CONSTANTS.ADS_ANALYTIC_EVENTS.LOGIN, {
					content_name: 'User Login',
					content_category: 'Authentication',
					method: 'Email',
					user_id: user.user_id,
				})
				this.$stanAnalytics('accounts-added', {
					meta: { user_id: user.user_id, username: user.username },
					props: {
						total_accounts: creatorsRealAccounts.length,
						user_ids: creatorsRealAccounts.map(data => data?.user_id),
					},
				})
			}
			if (origin === 'community') {
				const token = this.$store.getters['Auth/token']
				window.open(`${this.$configSettings.communityDomain}?token=${token}`)
			}
			if (sessionStorage.getItem('redirectTo')) {
				const redirectTo = sessionStorage.getItem('redirectTo')
				sessionStorage.removeItem('redirectTo')
				this.$router.push(redirectTo).catch(() => {
					this.$router.push({ name: 'dashboard' }).catch(() => {})
				})
			} else {
				this.$router.push({ name: 'dashboard' }).catch(() => {})
			}
		},
	},
}
